import { render, staticRenderFns } from "./materialUpload.vue?vue&type=template&id=4e0807d7&scoped=true&"
import script from "./materialUpload.vue?vue&type=script&lang=js&"
export * from "./materialUpload.vue?vue&type=script&lang=js&"
import style0 from "./materialUpload.vue?vue&type=style&index=0&id=4e0807d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0807d7",
  null
  
)

export default component.exports